import Checkbox from "components/Common/Form/Checkbox";
import FormInput from "components/Common/Form/Input/FormInput";
import { useEffect, useState } from "react";
import { useFormContext, useWatch } from "react-hook-form";
import { DspmStorageInfoType } from "src/service/types/pay.type";

const storageOptions: DspmStorageInfoType[] = [
  { cloudProvider: "AWS", storageCount: 1, storageGb: 100 },
  { cloudProvider: "Azure", storageCount: 1, storageGb: 100 },
  { cloudProvider: "GCP", storageCount: 1, storageGb: 100 },
];
// UI 표기명 → API 전송 코드 매핑 (화면은 기존 표기 유지, API 호출 시에만 코드로 변환)
const cloudProviderApiMap: Record<string, string> = {
  AWS: "AWS",
  Azure: "AZURE",
  GCP: "GCP",
};
const SelectDspmInfoList = () => {
  const [selectedStorage, setSelectedStorage] = useState<DspmStorageInfoType[]>(
    []
  );
  const {
    setValue,
    register,
    formState: { errors },
    control,
  } = useFormContext();
  const providerNames = storageOptions.map((o) => o.cloudProvider);
  const watchNames = [
    ...providerNames,
    ...providerNames.map((n) => `storageGb_${n}`),
    ...providerNames.map((n) => `storageCount_${n}`),
  ];
  const watched = useWatch({ control, name: watchNames });
  const providerCheckedMap = providerNames.reduce((acc, name, idx) => {
    acc[name] = Boolean(watched?.[idx]);
    return acc;
  }, {} as Record<string, boolean>);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const handleCheckboxChange = (checked: boolean, provider: string) => {
    setSelectedStorage((prev) => {
      if (checked) {
        return [
          ...prev,
          { cloudProvider: provider, storageGb: 100, storageCount: 1 },
        ];
      }
      return prev.filter((item) => item.cloudProvider !== provider);
    });
  };
  // 용량 및 개수 변경 핸들러
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const handleStorageChange = (
    provider: string,
    key: keyof DspmStorageInfoType,
    value: number | null
  ) => {
    if (value === null) return;

    setSelectedStorage((prev) =>
      prev.map((item) =>
        item.cloudProvider === provider ? { ...item, [key]: value } : item
      )
    );
  };
  void handleCheckboxChange;
  void handleStorageChange;
  useEffect(() => {
    const providerNamesLocal = storageOptions.map((o) => o.cloudProvider);
    const numProviders = providerNamesLocal.length;
    const startGbIndex = numProviders;
    const startCountIndex = startGbIndex + numProviders;

    const checkedByIndex = Array.from({ length: numProviders }, (_, idx) =>
      Boolean(watched?.[idx])
    );
    const storageGbByIndex = Array.from({ length: numProviders }, (_, idx) => {
      const raw = watched?.[startGbIndex + idx] as number | string | undefined;
      const num = Number(raw);
      return Number.isFinite(num) ? (num as number) : undefined;
    });
    const storageCountByIndex = Array.from(
      { length: numProviders },
      (_, idx) => {
        const raw = watched?.[startCountIndex + idx] as
          | number
          | string
          | undefined;
        const num = Number(raw);
        return Number.isFinite(num) ? (num as number) : undefined;
      }
    );

    const newSelected = storageOptions
      .map((o, idx) => ({ o, idx }))
      .filter(({ idx }) => checkedByIndex[idx])
      .map(({ o, idx }) => ({
        cloudProvider: cloudProviderApiMap[o.cloudProvider] ?? o.cloudProvider,
        storageGb: storageGbByIndex[idx] ?? 100,
        storageCount: storageCountByIndex[idx] ?? 1,
      }));

    const isSame =
      selectedStorage.length === newSelected.length &&
      selectedStorage.every((item, i) => {
        const other = newSelected[i];
        return (
          item.cloudProvider === other.cloudProvider &&
          item.storageGb === other.storageGb &&
          item.storageCount === other.storageCount
        );
      });

    if (!isSame) {
      setSelectedStorage(newSelected);
      setValue("dspmStorageInfo", newSelected);
    }
  }, [watched, setValue, selectedStorage]);
  return (
    <div>
      {storageOptions.map((option) => {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const isChecked = selectedStorage.some(
          (item) => item.cloudProvider === option.cloudProvider
        );

        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const currentData = selectedStorage.find(
          (item) => item.cloudProvider === option.cloudProvider
        );
        void isChecked;
        void currentData;

        return (
          <div
            key={option.cloudProvider}
            style={{ marginBottom: "10px" }}
          // align="middle"
          // gutter={16}
          // wrap={false}
          >
            <div style={{ display: "flex", alignItems: "center", gap: "20px" }}>
              {/* 체크박스 */}
              <div
                style={{ width: "65px", display: "flex", alignItems: "center" }}
              >
                <Checkbox
                  children={
                    <label htmlFor={option.cloudProvider}>
                      {option.cloudProvider}
                    </label>
                  }
                  name={option.cloudProvider}
                  register={register}
                  errors={errors}
                  checked={providerCheckedMap[option.cloudProvider] || false}
                ></Checkbox>
              </div>

              {/* 스토리지 입력란 (GB) */}
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "4px",
                  width: "30%",
                }}
              >
                <FormInput
                  name={`storageGb_${option.cloudProvider}`}
                  type="number"
                  min={0}
                  disabled={!providerCheckedMap[option.cloudProvider]}
                  register={register}
                />
                <label htmlFor="storageGb">GB</label>
              </div>

              {/* 개수 입력란 */}
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "4px",
                  width: "30%",
                }}
              >
                <FormInput
                  name={`storageCount_${option.cloudProvider}`}
                  type="number"
                  min={1}
                  disabled={!providerCheckedMap[option.cloudProvider]}
                  register={register}
                  errors={errors}
                />
                <span>개</span>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default SelectDspmInfoList;
